// extracted by mini-css-extract-plugin
module.exports = {"section":"get-in-touch-module--section--1xnzF","formContainer":"get-in-touch-module--formContainer--12WQs","contactForm":"get-in-touch-module--contactForm--3tX4B"};